import { render } from "./SectionSolutionCapbl.vue?vue&type=template&id=f44b8a24&scoped=true"
import script from "./SectionSolutionCapbl.vue?vue&type=script&lang=js"
export * from "./SectionSolutionCapbl.vue?vue&type=script&lang=js"

import "./SectionSolutionCapbl.vue?vue&type=style&index=0&id=f44b8a24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44b8a24"]])

export default __exports__